export default __webpack_public_path__ + "static/media/c3.19a1b18f.png";